import { CARRIER_GROUP_DELIVERY_PLAN_STEP_TYPE_SORT } from './../../../prompt/core/enum/carrier-group-delivery-plan-step-type';

export const isStepRelatedToAlignTrips = step => step.type !== CARRIER_GROUP_DELIVERY_PLAN_STEP_TYPE_SORT;
